import { createAction, props } from '@ngrx/store';

export const setPremiumTotalValueAction = createAction(
  '[PREMIUMTOTALVALUE] Set Premium Total Value',
  props<{ premiumTotalValue: number }>()
);